import {Action} from "@ngrx/store";

export const LOAD_WP_VERSION: string = '[info] Load Wordpress Version';
export const LOAD_WP_VERSION_SUCCESS: string = '[info] Load Wordpress Version Success';
export const LOAD_WP_VERSION_FAIL: string = '[info] Load Wordpress Version Fail';

export class LoadWordpressVersion implements Action {
  readonly type: string = LOAD_WP_VERSION;
  constructor(public payload: number) {}
}

export class LoadWordpressVersionSuccess implements Action {

  readonly type: string = LOAD_WP_VERSION_SUCCESS;
  constructor(public payload: {
    [id: string]: any
  }) {}

}

export class LoadWordpressVersionFail implements Action {

  readonly type: string = LOAD_WP_VERSION_FAIL;
  constructor(public payload: string) {}

}


export type wordpressVersionAction = LoadWordpressVersion | LoadWordpressVersionSuccess | LoadWordpressVersionFail;
